import Card from "../card";

const CardList = (props) => (
  <div>
    {props.cards.map((card) => (
      <Card {...card} />
    ))}
  </div>
);

export default CardList;
